import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to top of page on every route change (unless URL contains a hash).
 * Fixes the common React Router SPA behaviour where the scroll position
 * from the previous page is retained after navigation.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // Let the browser/HomePage handle in-page anchor scrolling
    // Use instant to avoid a jarring animation on route change
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
